import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { checkIndexOverflow3frtmheghr0th as checkIndexOverflow } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { RView1jxdnn5qf89cm as RView } from '../RView.commonHtml.mjs';
import { toDoubleOrNullkxwozihadygj as toDoubleOrNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import {
  Dimensions32ju1l7z4mh as Dimension,
  _Dimension___get_value__impl__urhqzr1mx919605mj8b as _Dimension___get_value__impl__urhqzr,
} from '../../models/data.mjs';
import {
  Companion_getInstanceok5aued8gko9 as Companion_getInstance,
  get_debugMode2ku08uo1anfv as get_debugMode,
  get_viewDebugTarget2umd1p7wjmzxt as get_viewDebugTarget,
} from '../../debugger.mjs';
import { indexOfa2zokh3tu4p6 as indexOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance_0 } from '../../ViewWrapper.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      lbg(on, index, view) {
        if (index >= 1) {
          // Inline function 'com.lightningkite.kiteui.views.display' call
          var tmp = on.tb5_1.bb4_1.fb7_1.display;
          if (!(((!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null) === 'grid')) {
            // Inline function 'com.lightningkite.kiteui.views.display' call
            on.tb5_1.bb4_1.fb7_1.display = 'grid';
            on.tb5_1.ab9('grid-template-columns', '100%');
            on.tb5_1.ab9('grid-template-rows', '100%');
          }
        }
        // Inline function 'kotlin.collections.forEachIndexed' call
        var index_0 = 0;
        var _iterator__ex2g4s = on.tb5_1.oba().m1();
        while (_iterator__ex2g4s.n1()) {
          var item = _iterator__ex2g4s.o1();
          var _unary__edvuaz = index_0;
          index_0 = _unary__edvuaz + 1 | 0;
          var index_1 = checkIndexOverflow(_unary__edvuaz);
          var tmp0 = item.bb4_1;
          // Inline function 'com.lightningkite.kiteui.views.zIndex' call
          var value = index_1.toString();
          tmp0.fb7_1.zIndex = value;
        }
        view.tb5_1.ab9('grid-area', '1 / 1 / 1 / 1');
        var tmp0_subject = view.tb5_1.cb4_1;
        switch (tmp0_subject == null ? -1 : tmp0_subject.b4_1) {
          case 0:
            // Inline function 'com.lightningkite.kiteui.views.verticalAlign' call

            view.tb5_1.bb4_1.fb7_1.verticalAlign = 'top';
            // Inline function 'com.lightningkite.kiteui.views.alignSelf' call

            view.tb5_1.bb4_1.fb7_1.alignSelf = 'start';
            break;
          case 1:
            // Inline function 'com.lightningkite.kiteui.views.display' call

            var tmp_0 = on.tb5_1.bb4_1.fb7_1.display;
            if (!(((!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : null) === 'grid')) {
              // Inline function 'com.lightningkite.kiteui.views.display' call
              on.tb5_1.bb4_1.fb7_1.display = 'grid';
              on.tb5_1.ab9('grid-template-columns', '100%');
              on.tb5_1.ab9('grid-template-rows', '100%');
            }

            // Inline function 'com.lightningkite.kiteui.views.alignSelf' call

            view.tb5_1.bb4_1.fb7_1.alignSelf = 'center';
            break;
          case 2:
            // Inline function 'com.lightningkite.kiteui.views.verticalAlign' call

            view.tb5_1.bb4_1.fb7_1.verticalAlign = 'bottom';
            // Inline function 'com.lightningkite.kiteui.views.alignSelf' call

            view.tb5_1.bb4_1.fb7_1.alignSelf = 'end';
            break;
          default:
            // Inline function 'com.lightningkite.kiteui.views.verticalAlign' call

            view.tb5_1.bb4_1.fb7_1.verticalAlign = 'top';
            // Inline function 'com.lightningkite.kiteui.views.height' call

            var tmp_1 = view.tb5_1.bb4_1.fb7_1.height;
            // Inline function 'kotlin.text.isNullOrEmpty' call

            var this_0 = (!(tmp_1 == null) ? typeof tmp_1 === 'string' : false) ? tmp_1 : null;
            if (this_0 == null || charSequenceLength(this_0) === 0) {
              // Inline function 'com.lightningkite.kiteui.views.height' call
              view.tb5_1.bb4_1.fb7_1.height = '100%';
            }

            // Inline function 'com.lightningkite.kiteui.views.alignSelf' call

            view.tb5_1.bb4_1.fb7_1.alignSelf = 'stretch';
            break;
        }
        var tmp1_subject = view.tb5_1.db4_1;
        switch (tmp1_subject == null ? -1 : tmp1_subject.b4_1) {
          case 0:
            // Inline function 'com.lightningkite.kiteui.views.marginLeft' call

            view.tb5_1.bb4_1.fb7_1.marginLeft = 'unset';
            // Inline function 'com.lightningkite.kiteui.views.marginRight' call

            view.tb5_1.bb4_1.fb7_1.marginRight = 'auto';
            // Inline function 'com.lightningkite.kiteui.views.justifySelf' call

            view.tb5_1.bb4_1.fb7_1.justifySelf = 'start';
            break;
          case 1:
            // Inline function 'com.lightningkite.kiteui.views.marginLeft' call

            view.tb5_1.bb4_1.fb7_1.marginLeft = 'auto';
            // Inline function 'com.lightningkite.kiteui.views.marginRight' call

            view.tb5_1.bb4_1.fb7_1.marginRight = 'auto';
            // Inline function 'com.lightningkite.kiteui.views.justifySelf' call

            view.tb5_1.bb4_1.fb7_1.justifySelf = 'center';
            break;
          case 2:
            // Inline function 'com.lightningkite.kiteui.views.marginLeft' call

            view.tb5_1.bb4_1.fb7_1.marginLeft = 'auto';
            // Inline function 'com.lightningkite.kiteui.views.marginRight' call

            view.tb5_1.bb4_1.fb7_1.marginRight = 'unset';
            // Inline function 'com.lightningkite.kiteui.views.justifySelf' call

            view.tb5_1.bb4_1.fb7_1.justifySelf = 'end';
            break;
          default:
            // Inline function 'com.lightningkite.kiteui.views.width' call

            var tmp_2 = view.tb5_1.bb4_1.fb7_1.width;
            // Inline function 'kotlin.text.isNullOrEmpty' call

            var this_1 = (!(tmp_2 == null) ? typeof tmp_2 === 'string' : false) ? tmp_2 : null;
            if (this_1 == null || charSequenceLength(this_1) === 0) {
              // Inline function 'com.lightningkite.kiteui.views.width' call
              view.tb5_1.bb4_1.fb7_1.width = '100%';
            }

            // Inline function 'com.lightningkite.kiteui.views.justifySelf' call

            view.tb5_1.bb4_1.fb7_1.justifySelf = 'stretch';
            break;
        }
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_1() {
  return Companion_instance;
}
var FrameClass;
function Frame() {
  if (FrameClass === VOID) {
    class $ extends RView() {
      constructor(context) {
        super(context);
        this.tb5_1.xb3_1 = 'div';
        var tmp0 = this.tb5_1.bb4_1;
        // Inline function 'com.lightningkite.kiteui.views.lineHeight' call
        var value = '0px !important';
        tmp0.fb7_1.lineHeight = value;
      }
      ub9(index, view) {
        super.ub9(index, view);
        Companion_instance.lbg(this, index, view);
      }
    }
    initMetadataForClass($, 'Frame');
    FrameClass = $;
  }
  return FrameClass;
}
function _set_complex__k605rf($this, value) {
  $this.tb8_1 = value;
  if (!value)
    $this.tb5_1.hb4_1.v('optimized');
  else
    $this.tb5_1.hb4_1.w3('optimized');
}
function enterFlexMode($this) {
  if (!$this.tb8_1) {
    _set_complex__k605rf($this, true);
    // Inline function 'com.lightningkite.kiteui.views.display' call
    $this.tb5_1.bb4_1.fb7_1.display = 'flex';
    var _iterator__ex2g4s = $this.oba().m1();
    while (_iterator__ex2g4s.n1()) {
      var child = _iterator__ex2g4s.o1();
      // Inline function 'com.lightningkite.kiteui.views.marginBottom' call
      child.tb5_1.bb4_1.fb7_1.marginBottom = '0px';
    }
  }
}
var RowOrColClass;
function RowOrCol() {
  if (RowOrColClass === VOID) {
    class $ extends RView() {
      constructor(context) {
        super(context);
        this.tb5_1.xb3_1 = 'div';
        // Inline function 'com.lightningkite.kiteui.views.flexDirection' call
        this.tb5_1.bb4_1.fb7_1.flexDirection = 'column';
        var tmp0 = this.tb5_1.hb4_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var element = 'kiteui-flex';
        tmp0.v(element);
        var tmp0_0 = this.tb5_1.hb4_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var element_0 = 'kiteui-col';
        tmp0_0.v(element_0);
        this.tb5_1.hb4_1.v('optimized');
        this.tb8_1 = false;
        this.ub8_1 = true;
      }
      xbm(value) {
        this.ub8_1 = value;
        var tmp0 = this.tb5_1.bb4_1;
        // Inline function 'com.lightningkite.kiteui.views.flexDirection' call
        var value_0 = value ? 'column' : 'row';
        tmp0.fb7_1.flexDirection = value_0;
        if (value) {
          var tmp0_0 = this.tb5_1.hb4_1;
          // Inline function 'kotlin.collections.minusAssign' call
          var element = 'kiteui-row';
          tmp0_0.w3(element);
          var tmp0_1 = this.tb5_1.hb4_1;
          // Inline function 'kotlin.collections.plusAssign' call
          var element_0 = 'kiteui-col';
          tmp0_1.v(element_0);
        } else {
          var tmp0_2 = this.tb5_1.hb4_1;
          // Inline function 'kotlin.collections.minusAssign' call
          var element_1 = 'kiteui-col';
          tmp0_2.w3(element_1);
          var tmp0_3 = this.tb5_1.hb4_1;
          // Inline function 'kotlin.collections.plusAssign' call
          var element_2 = 'kiteui-row';
          tmp0_3.v(element_2);
        }
      }
      ub9(index, view) {
        super.ub9(index, view);
        var tmp;
        if (!this.ub8_1) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.kiteui.views.flexGrow' call
          var tmp_0 = view.tb5_1.bb4_1.fb7_1.flexGrow;
          var tmp0_safe_receiver = (!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : null;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : toDoubleOrNull(tmp0_safe_receiver);
          var tmp_1;
          if (tmp1_safe_receiver == null) {
            tmp_1 = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp_1 = tmp1_safe_receiver > 0.0;
          }
          tmp = tmp_1 === true;
        }
        if (tmp) {
          enterFlexMode(this);
        }
        var align = this.ub8_1 ? view.tb5_1.db4_1 : view.tb5_1.cb4_1;
        switch (align == null ? -1 : align.b4_1) {
          case 0:
            // Inline function 'com.lightningkite.kiteui.views.alignSelf' call

            view.tb5_1.bb4_1.fb7_1.alignSelf = 'start';
            break;
          case 1:
            // Inline function 'com.lightningkite.kiteui.views.alignSelf' call

            view.tb5_1.bb4_1.fb7_1.alignSelf = 'center';
            break;
          case 2:
            // Inline function 'com.lightningkite.kiteui.views.alignSelf' call

            view.tb5_1.bb4_1.fb7_1.alignSelf = 'end';
            break;
          default:
            // Inline function 'com.lightningkite.kiteui.views.alignSelf' call

            view.tb5_1.bb4_1.fb7_1.alignSelf = 'stretch';
            break;
        }
        if (!this.tb8_1) {
          switch (align == null ? -1 : align.b4_1) {
            case 0:
              // Inline function 'com.lightningkite.kiteui.views.marginLeft' call

              view.tb5_1.bb4_1.fb7_1.marginLeft = 'unset';
              // Inline function 'com.lightningkite.kiteui.views.marginRight' call

              view.tb5_1.bb4_1.fb7_1.marginRight = 'auto';
              // Inline function 'com.lightningkite.kiteui.views.width' call

              var tmp_2 = view.tb5_1.bb4_1.fb7_1.width;
              // Inline function 'kotlin.let' call

              var it = (!(tmp_2 == null) ? typeof tmp_2 === 'string' : false) ? tmp_2 : null;
              if (it == null || it === '') {
                var tmp0 = view.tb5_1.bb4_1;
                // Inline function 'com.lightningkite.kiteui.views.width' call
                var value = 'fit-content';
                tmp0.fb7_1.width = value;
              }

              break;
            case 1:
              // Inline function 'com.lightningkite.kiteui.views.marginLeft' call

              view.tb5_1.bb4_1.fb7_1.marginLeft = 'auto';
              // Inline function 'com.lightningkite.kiteui.views.marginRight' call

              view.tb5_1.bb4_1.fb7_1.marginRight = 'auto';
              // Inline function 'com.lightningkite.kiteui.views.width' call

              var tmp_3 = view.tb5_1.bb4_1.fb7_1.width;
              // Inline function 'kotlin.let' call

              var it_0 = (!(tmp_3 == null) ? typeof tmp_3 === 'string' : false) ? tmp_3 : null;
              if (it_0 == null || it_0 === '') {
                var tmp0_0 = view.tb5_1.bb4_1;
                // Inline function 'com.lightningkite.kiteui.views.width' call
                var value_0 = 'fit-content';
                tmp0_0.fb7_1.width = value_0;
              }

              break;
            case 2:
              // Inline function 'com.lightningkite.kiteui.views.marginLeft' call

              view.tb5_1.bb4_1.fb7_1.marginLeft = 'auto';
              // Inline function 'com.lightningkite.kiteui.views.marginRight' call

              view.tb5_1.bb4_1.fb7_1.marginRight = 'unset';
              // Inline function 'com.lightningkite.kiteui.views.width' call

              var tmp_4 = view.tb5_1.bb4_1.fb7_1.width;
              // Inline function 'kotlin.let' call

              var it_1 = (!(tmp_4 == null) ? typeof tmp_4 === 'string' : false) ? tmp_4 : null;
              if (it_1 == null || it_1 === '') {
                var tmp0_1 = view.tb5_1.bb4_1;
                // Inline function 'com.lightningkite.kiteui.views.width' call
                var value_1 = 'fit-content';
                tmp0_1.fb7_1.width = value_1;
              }

              break;
            default:
              // Inline function 'com.lightningkite.kiteui.views.width' call

              var tmp_5 = view.tb5_1.bb4_1.fb7_1.width;
              // Inline function 'kotlin.text.isNullOrEmpty' call

              var this_0 = (!(tmp_5 == null) ? typeof tmp_5 === 'string' : false) ? tmp_5 : null;
              if (this_0 == null || charSequenceLength(this_0) === 0) {
                // Inline function 'com.lightningkite.kiteui.views.width' call
                view.tb5_1.bb4_1.fb7_1.width = '100%';
              }

              break;
          }
        }
        this.vb8();
      }
      yb9() {
        super.yb9();
        this.vb8();
      }
      wb9(index) {
        super.wb9(index);
        this.vb8();
      }
      zba() {
        super.zba();
        this.vb8();
      }
      vb8() {
        if (!this.tb8_1) {
          var tmp0 = this.oba();
          var tmp$ret$2;
          $l$block: {
            // Inline function 'kotlin.collections.lastOrNull' call
            var iterator = tmp0.u1(tmp0.p1());
            while (iterator.v6()) {
              var element = iterator.x6();
              // Inline function 'com.lightningkite.kiteui.views.hidden' call
              var tmp = element.tb5_1.zb3_1.ib7_1.hidden;
              if (!(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true)) {
                tmp$ret$2 = element;
                break $l$block;
              }
            }
            tmp$ret$2 = null;
          }
          var newLastShownElement = tmp$ret$2;
          var tmp0_elvis_lhs = this.bb9();
          var tmp_0;
          var tmp_1 = tmp0_elvis_lhs;
          if ((tmp_1 == null ? null : new (Dimension())(tmp_1)) == null) {
            tmp_0 = this.kba().hb0_1;
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }
          var amnt = tmp_0;
          var _iterator__ex2g4s = this.oba().m1();
          while (_iterator__ex2g4s.n1()) {
            var child = _iterator__ex2g4s.o1();
            var tmp0_0 = child.tb5_1.bb4_1;
            // Inline function 'com.lightningkite.kiteui.views.marginBottom' call
            var value = _Dimension___get_value__impl__urhqzr(amnt).toString();
            tmp0_0.fb7_1.marginBottom = value;
          }
          // Inline function 'com.lightningkite.kiteui.debugPrint' call
          if (get_debugMode() && equals(get_viewDebugTarget(), this)) {
            var tmp_2 = Companion_getInstance().zbm('viewDebugTarget');
            var tmp$ret$4 = 'last shown index: ' + indexOf(this.oba(), newLastShownElement);
            tmp_2.abn([tmp$ret$4]);
          }
          var tmp2_safe_receiver = newLastShownElement == null ? null : newLastShownElement.tb5_1;
          var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.bb4_1;
          if (tmp3_safe_receiver == null)
            null;
          else {
            // Inline function 'com.lightningkite.kiteui.views.marginBottom' call
            tmp3_safe_receiver.fb7_1.marginBottom = '0';
          }
        }
      }
      bbn(amount) {
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
        var prev = this.bbb_1;
        var tmp = this;
        tmp.bbb_1 = (_this__u8e3s4) => {
          var tmp0_safe_receiver = prev;
          if (tmp0_safe_receiver == null)
            null;
          else
            tmp0_safe_receiver(_this__u8e3s4);
          if (this.ub8_1) {
            var tmp0 = _this__u8e3s4.tb5_1.bb4_1;
            // Inline function 'com.lightningkite.kiteui.views.marginTop' call
            var value = 'calc(' + _Dimension___get_value__impl__urhqzr(amount).toString() + ' - var(--parentSpacing))';
            tmp0.fb7_1.marginTop = value;
          } else {
            var tmp0_0 = _this__u8e3s4.tb5_1.bb4_1;
            // Inline function 'com.lightningkite.kiteui.views.marginLeft' call
            var value_0 = 'calc(' + _Dimension___get_value__impl__urhqzr(amount).toString() + ' - var(--parentSpacing))';
            tmp0_0.fb7_1.marginLeft = value_0;
          }
          return Unit_instance;
        };
        Companion_getInstance_0();
      }
      sb9(theme) {
        super.sb9(theme);
        var theme_0 = theme.eb1_1;
        this.vb8();
      }
    }
    initMetadataForClass($, 'RowOrCol');
    RowOrColClass = $;
  }
  return RowOrColClass;
}
var RowCollapsingToColumnClass;
function RowCollapsingToColumn() {
  if (RowCollapsingToColumnClass === VOID) {
    class $ extends RView() {
      constructor(context, breakpoints) {
        super(context);
        this.tb5_1.xb3_1 = 'div';
        this.tb5_1.hb4_1.v(context.ob3_1.kb3(breakpoints));
        this.tb5_1.hb4_1.v('rowCollapsing');
      }
    }
    initMetadataForClass($, 'RowCollapsingToColumn');
    RowCollapsingToColumnClass = $;
  }
  return RowCollapsingToColumnClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Frame as Frame1e7t2kcdb3wu7,
  RowCollapsingToColumn as RowCollapsingToColumn13iucsgmjquhb,
  RowOrCol as RowOrCol3a33s3yce2tuv,
  Companion_instance as Companion_instance15pczmasjuxgh,
};
//endregion

//# sourceMappingURL=ContainingView.commonHtml.mjs.map
